<!--
  --
  -- 個人情報のサマリ コンポーネント
  --
  -->
<template>
  <c-summary-sheet>
    <template #title>個人情報</template>

    <template>
      <!-- 氏名 -->
      <c-summary-item>
        <template #caption>氏名</template>
        <template #value>{{profile.familyName}} {{profile.givenName}}</template>
      </c-summary-item>

      <!-- 性別 -->
      <c-summary-item>
        <template #caption>性別</template>
        <template #value>{{profile.gender | genderName}}</template>
      </c-summary-item>

      <!-- 生年月日 -->
      <c-summary-item>
        <template #caption>生年月日</template>
        <template #value>{{profile.birthday | timeformat('J K 年 m 月 d 日')}} ({{profile.birthday | age}}歳)</template>
      </c-summary-item>

      <!-- 住所 -->
      <c-summary-item>
        <template #caption>住所</template>
        <template #value>{{profile.address1}} {{profile.address2}}</template>
      </c-summary-item>

      <!-- 電話番号 -->
      <c-summary-item>
        <template #caption>電話番号</template>
        <template #value>{{profile.phone}}</template>
      </c-summary-item>

    </template>
  </c-summary-sheet>
</template>

<script>
import CSummarySheet from './CSummarySheet'
import CSummaryItem from './CSummaryItem'

import * as C from '@/consts'
import * as time from '@/libs/time'

export default {
  name: 'CSummaryProfile',
  components: {
    CSummarySheet,
    CSummaryItem
  },

  props: {
    profile: {
      type: Object,
      required: true
    }
  },
  filters: {
    genderName (gender) {
      switch (gender) {
        case C.SEX_NOT_KNOWN: return '不明'
        case C.MALE: return '男性'
        case C.FEMALE: return '女性'
      }
      return '回答しない'
    },

    age (birthday) {
      const birth = time.create(birthday)
      if (!birth) {
        return ''
      }

      const dur = time.duration(time.today(), birth)
      return (dur / time.YEAR) | 0
    }
  }
}
</script>
